// src/components/shared/ScrollToTop.jsx
// Rendered once inside the router so every navigation starts at the top.
// Scrolling smoothly is what used to strand people at the bottom of the next page:
// the incoming page lays out mid-animation and the browser abandons the scroll there.

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HEADER_OFFSET = 90; // the nav is sticky, so an anchor at 0 would sit under it

export default function ScrollToTop() {
  const { key, hash } = useLocation();

  // Otherwise the browser restores the old offset on back/forward and on reload.
  useLayoutEffect(() => {
    if (!('scrollRestoration' in window.history)) return undefined;
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  // Keyed on location.key, not pathname: back, forward and same-path pushes all count.
  useLayoutEffect(() => {
    const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
    const top = target ? window.scrollY + target.getBoundingClientRect().top - HEADER_OFFSET : 0;
    window.scrollTo(0, Math.max(0, top));
  }, [key, hash]);

  return null;
}
